import { render, staticRenderFns } from "./SiteDocumentTable.vue?vue&type=template&id=79887bc8&"
import script from "./SiteDocumentTable.vue?vue&type=script&lang=js&"
export * from "./SiteDocumentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports